<div *ngIf="course" class="flex p-3 gap-3 surface-0 border-round shadow-2">
  <p-card class="mr-2 custom-card-body-padding">
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-calendar text-primary text-xl ml-2"></i>
        <span class="font-semibold">Booking</span>
      </div>
    </ng-template>
    <div class="flex flex-column gap-2 w-12rem">
      <div class="flex align-items-center gap-2 text-sm">
        <i class="pi pi-clock text-primary"></i>
        <span>From:</span>
        <span class="font-medium">{{ period?.from }}</span>
      </div>
      <div class="flex align-items-center gap-2 text-sm">
        <i class="pi pi-clock text-primary"></i>
        <span>To:</span>
        <span class="font-medium">{{ period?.to }}</span>
      </div>
      <div class="flex align-items-center gap-2 text-sm">
        <span>
          <i *ngIf="period?.autoHotdeal" class="pi pi-check-circle text-green-500"></i>
          <i *ngIf="!period?.autoHotdeal" class="pi pi-times-circle text-gray-400"></i>
        </span>
        <span class="font-medium">Hot Deal Enabled</span>
      </div>
    </div>
  </p-card>
  <p-card class="w-18rem mr-2 custom-card-body-padding">
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-shopping-cart text-primary text-xl ml-2"></i>
        <span class="font-semibold text-lg">Cart</span>
      </div>
    </ng-template>
    <div class="flex flex-column gap-2 w-13rem">
      <div class="flex align-items-center gap-2 text-sm">
        <i class="pi pi-exclamation-circle text-primary"></i>
        <span>Require:</span>
        <span class="font-medium">{{ cartSettingView?.require }}</span>
      </div>
      <div class="flex align-items-center gap-2 text-sm">
        <i class="pi pi-dollar text-primary"></i>
        <span>Course Price:</span>
        <span class="font-medium">{{ cartSettingView?.coursePrice }}</span>
      </div>
      <div class="flex align-items-center gap-2 text-sm">
        <i class="pi pi-tag text-primary"></i>
        <span>Golfdigg Price:</span>
        <span class="font-medium">{{ cartSettingView?.golfdiggPrice }}</span>
      </div>
    </div>
  </p-card>
  <div class="bg-yellow-100 text-xs border-round shadow-2 w-full p-3">
    <p-scrollPanel>
      <p class="text-blue-400">{{ course.note }}</p>
    </p-scrollPanel>
  </div>
</div>
